import { Jio_Saavan_axios_adapter } from "./Jio_Saavan_axios_adapter";
import Jio_Saavan_sonstant from './Jio_Saavan_sonstant';

const Jio_Saavan_api_service = {

    searchArtistSongsByArtistIDAndPage: async (artistID) => {
        //const allSongs = [];
        const allSongs = new Map();
        let currentPage = 0;
        let totalPages = 1;

        try {
            while (currentPage <= totalPages) {
                const response = await Jio_Saavan_axios_adapter.get(`${Jio_Saavan_sonstant.ENDPOINT_JIO_SAAVAN.ARTISTS}/${artistID}/songs`,
                    {
                        params: {
                            page: currentPage,

                            /**
                             * popularity,latest,alphabetical
                             */
                            sortBy: "popularity",

                            /**
                             * asc,desc
                             */
                            sortOrder: "desc"
                        }
                    }
                );
                if (response?.data?.success && response?.data?.data) {
                    const { songs = [], total = 0 } = response.data.data;
                    if (songs.length === 0) {
                        //console.log("currentPage0 : ", currentPage)
                        break;
                    }

                    //allSongs.push(...songs);

                    // Add unique songs to the map
                    for (const song of songs) {
                        const uniqueKey = song.id || song.songid || song._id; // update based on actual field
                        if (uniqueKey && !allSongs.has(uniqueKey)) {
                            allSongs.set(uniqueKey, song);
                        }
                    }


                    if (currentPage === 0) {
                        const perPage = 10;
                        totalPages = Math.ceil(total / perPage);
                        console.log("total : ", total)
                        console.log("total pages : ", totalPages)
                    }
                    //console.log("currentPage1 : ", currentPage)
                    currentPage++;
                } else {
                    console.log("currentPage : ", currentPage)
                    console.log("total pages : ", totalPages)
                    console.log("jio saavan api exit cause of condition failure")
                    break; // exit loop on failure
                }
            }

            return {
                success: true,
                total: allSongs.length,
                songs: Array.from(allSongs.values()),
            };
        } catch (error) {
            console.log("jio saavan api error => ", error)
            return {
                success: false,
                message: "Track API Error - Jio Saavn",
                error: error.message || error,
            };
        }
    },

    searchEverythingByName: async (query) => {
        const filterBy = "artist";
        try {
            const response = await Jio_Saavan_axios_adapter.get(`${Jio_Saavan_sonstant.ENDPOINT_JIO_SAAVAN.SEARCH_SINGLE}`,
                {
                    params: { "query": "" + query },
                paramsSerializer: params => {
                        // custom serializer that replaces space with %20 instead of +
                        return Object.entries(params)
                            .map(([key, val]) => `${key}=${val.replace(/ /g, '%20')}`)
                            .join('&');
                    }
                },
            );

            //console.log("res => ", response)
            const results = response?.data?.data?.topQuery?.results;

            if (Array.isArray(results)) {
                const artist = results.find(item =>
                    item?.type?.toLowerCase() === filterBy
                );

                if (artist) {
                    return {
                        success: true,
                        artist
                    };
                }
            }

            return {
                success: false,
                message: "Artist Not Found - Jio Saavn",
                originalResponse: response?.data
            };
        } catch (error) {
            return {
                success: false,
                message: "Artist API Error - Jio Saavn",
                error: error.message || error
            };
        }
    },

    searchTracksOnlyByName: async (query) => {
        try {
            const response = await Jio_Saavan_axios_adapter.get(`${Jio_Saavan_sonstant.ENDPOINT_JIO_SAAVAN.SEARCH_MULTIPLE}`,
                {
                    params: { query: query }
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    trackDetail: async (id) => {
        try {
            const response = await Jio_Saavan_axios_adapter.get(`${Jio_Saavan_sonstant.ENDPOINT_JIO_SAAVAN.TRACK_INFO}`,
                {
                    params: { ids: id },
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    albumDetail: async (id) => {
        try {
            const response = await Jio_Saavan_axios_adapter.get(`${Jio_Saavan_sonstant.ENDPOINT_JIO_SAAVAN.ALBUMS}`,
                {
                    params: { id: id },
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

    artistDetail: async (id) => {
        try {
            const response = await Jio_Saavan_axios_adapter.get(`${Jio_Saavan_sonstant.ENDPOINT_JIO_SAAVAN.ARTISTS}`,
                {
                    params: { id: id },
                }
            );
            return response.data;
        } catch (error) {
            return error;
        }
    },

}

export default Jio_Saavan_api_service;